import React, { createContext, useContext } from 'react';

const FormLockContext = createContext(false);

export function FormLockProvider({
  locked,
  children,
}: {
  locked: boolean;
  children: React.ReactNode;
}) {
  return (
    <FormLockContext.Provider value={locked}>
      {children}
    </FormLockContext.Provider>
  );
}

/** True when this step must not change a submitted application. */
export function useFormLocked(): boolean {
  return useContext(FormLockContext);
}
